export const graphName = {
  FUSE_STORAGE: "FUSE_STORAGE",
  FUSE_MEMORY: "FUSE_MEMORY",
  FUSE_CPU: "FUSE_CPU",
};

export const kpiTestResultLevel = {
  LOW: "low",
  MED: "med",
  HIGH: "high",
};
